import { Component, Inject, LOCALE_ID, OnDestroy, OnInit, signal } from "@angular/core";
import { Subscription } from "rxjs";

import { AuthService } from "@jwt";
import { CldrIntlService, IntlService } from "@progress/kendo-angular-intl";

@Component({
    selector: "app-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.css"]
})
export class HeaderComponent implements OnInit, OnDestroy {
    title = "Angular.Jwt.Core";

    isLoggedIn = false;
    subscription: Subscription | null = null;
    public value = 42.123;
    public date = new Date();
    displayName: string;

    public onLocaleChange(ev: Event): void {
        const locale = (ev.target as HTMLInputElement).value;
        this.localeId = locale;
        (<CldrIntlService>this.intlService).localeId = locale;
    }

    constructor(@Inject(LOCALE_ID) public localeId: string, public intlService: IntlService, private authService: AuthService) {
    }

    ngOnInit() {
        this.subscription = this.authService.authStatus$.subscribe(status => {
            this.isLoggedIn = status;
            if (status) {
                const authUser = this.authService.getAuthUser();
                this.displayName = authUser ? authUser.displayName : "";
            }
        });
    }

    ngOnDestroy() {
        // prevent memory leak when component is destroyed
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    logout() {
        this.authService.logout(true);
    }

}
